export default __webpack_public_path__ + "static/media/help.684c8c0d.svg";